import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får personalen dricka alkohol under arbetspasset?";
const SHORT_ANSWER = "Nej. Servingsansvarig och annan personal som hanterar alkohol får inte vara påverkade under arbetspasset. Det är en självklar tillsynsfråga.";

export const Route = createFileRoute("/fraga/far-personalen-dricka-pa-jobbet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får personalen dricka alkohol under arbetspasset" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Det är inte uttryckligen förbjudet i alkohollagen, men tillsynsorgan och försäkringsbolag anser det vara grovt oaktsamt. Risk för varning eller återkallat tillstånd."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Personalansvar och alkoholservering" }}
      related={[{"to": "/fraga/vad-ar-ordningsvakter-och-nar-kravs-de", "label": "När krävs ordningsvakter på en restaurang?"}, {"to": "/fraga/vad-galler-vid-tillsynsbesok", "label": "Vad gäller vid ett tillsynsbesök?"}, {"to": "/fraga/vad-galler-vid-personalfest", "label": "Får jag servera alkohol på personalfest utan extra tillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får personalen dricka på jobbet? Nej – detta gäller 2026" },
      { name: "description", content: "Nej – serveringsansvarig och personal får inte vara påverkade under passet. Se vad tillsynen kontrollerar och vilka sanktioner som kan följa." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-personalen-dricka-pa-jobbet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-personalen-dricka-pa-jobbet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-personalen-dricka-pa-jobbet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får personalen dricka alkohol under arbetspasset", url: "https://alkoholprovet.se/fraga/far-personalen-dricka-pa-jobbet" },
      ]),
    ],
  }),
});
